import { useSelector } from 'react-redux';
import { modalQueueLengthSelector } from './slice';

export const useQueueLength = () => useSelector(modalQueueLengthSelector);
